var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubstitutionOn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0374 5.08714L3.86667 5.08714C3.38802 5.08714 3 5.49415 3 5.99623C3 6.4983 3.38802 6.90532 3.86667 6.90532L13.0446 6.90532L10.6205 9.44809C10.2821 9.80311 10.2821 10.3787 10.6205 10.7337C10.959 11.0888 11.5077 11.0888 11.8462 10.7337L15.7462 6.64282C15.9158 6.46484 16.0005 6.2314 16 5.99812L16 5.99623C16 5.72006 15.8826 5.47266 15.6973 5.30593L11.8462 1.26627C11.5077 0.911244 10.959 0.911244 10.6205 1.26627C10.2821 1.62129 10.2821 2.19689 10.6205 2.55192L13.0374 5.08714Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.82313 13.5477L7.46667 13.5477C7.76122 13.5477 8 13.3035 8 13.0023C8 12.701 7.76122 12.4568 7.46667 12.4568L1.8187 12.4568L3.31046 10.9311C3.51874 10.7181 3.51874 10.3728 3.31046 10.1598C3.10218 9.94675 2.76449 9.94675 2.55621 10.1598L0.15621 12.6143C0.0517895 12.7211 -0.000280072 12.8612 1.52947e-06 13.0011L4.16705e-07 13.0023C3.94976e-07 13.168 0.072244 13.3164 0.186275 13.4164L2.55621 15.8402C2.76449 16.0533 3.10218 16.0533 3.31046 15.8402C3.51874 15.6272 3.51874 15.2819 3.31046 15.0689L1.82313 13.5477Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubstitutionOn);
export default __webpack_public_path__ + "static/media/substitution-on.f44df648c28fe8f89f458ca006924d4f.svg";
export { ForwardRef as ReactComponent };